export default __webpack_public_path__ + "static/media/error-404.7b794be8.png";